export default __webpack_public_path__ + "static/media/LoginEye.134c0b41.svg";